/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./updateBlob.defs.js";
export { main as default } from "./updateBlob.defs.js";
